// extracted by mini-css-extract-plugin
module.exports = {"row":"ClientBlock_row__1gtVf"};